/* eslint-disable react/jsx-no-target-blank */
import {
  Button,
  Highlight,
  HStack,
  Image,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import Tilt from "react-parallax-tilt";
import { GoDeviceCameraVideo } from "react-icons/go";
import { ViewIcon } from "@chakra-ui/icons";
import { BsGithub } from "react-icons/bs";

import Aos from "aos";
import "aos/dist/aos.css";

import bewakoof from "../images/bewakoof.gif";
import makosGIF from "../images/makosGIF.gif";
import hotjar from "../images/hotjar.gif";
import portfolio from "../images/portfolio.gif";
import naukri from "../images/naukri.gif";
import uborik from "../images/uborik.gif";
import justshop from "../images/justshop.gif";
import gymproject from "../images/gymproject.gif";
import stackbox from "../images/stackbox.gif";
import management from "../images/management.png";
import youtube from "../images/youtube.png";
import artfluir from "../images/artfluir.jpeg";
import techTrade from "../images/techTrade.jpeg";
import xseedAI from "../images/xseed.gif";
import planKeeper from "../images/planKeeper.gif";
import pehchaan from "../images/pehchaan.gif";

const projects = [
  // 👨‍💻 PERSONAL PROJECTS
  {
    type: "Freelance",
    name: "Gym.com",
    image: gymproject,
    description:
      "Fitness platform for workout plans, supplements, and gym equipment. Includes payment integration, user tracking, and admin panel.",
    tech: "React.js, Node.js, MongoDB, Redux, RazorPay",
    view: "https://gymbro.vercel.app/",
    git: "https://github.com/suFi7867/gym.com",
    video:
      "https://www.linkedin.com/feed/update/urn:li:activity:7010967664357457920/",
  },
  {
    type: "Freelance",
    name: "JustShop",
    image: justshop,
    description:
      "E-commerce clothing site with payment integration, product filtering, responsive design, and an admin panel.",
    tech: "React.js, Node.js, Redux, MongoDB, Chakra UI",
    view: "https://justshop-unit5-project.netlify.app/",
    git: "https://github.com/suFi7867/JustShop.com",
    video:
      "https://www.linkedin.com/feed/update/urn:li:activity:6997582095241875457/",
  },
  {
    type: "Personal",
    name: "Bewakoof.com",
    image: bewakoof,
    description:
      "Bewakoof.com clone implementing full e-commerce flow, smooth UI, and responsive design.",
    tech: "HTML, CSS, JavaScript, React.js, Chakra UI",
    view: "https://bewakoof-clone-sufi.vercel.app/",
    git: "https://github.com/suFi7867/Bewakoof.com-Clone",
    video:
      "https://www.linkedin.com/feed/update/urn:li:activity:6983691453747073024/",
  },
  {
    type: "Personal",
    name: "Hotjar",
    image: hotjar,
    description:
      "Web analytics clone visualizing user behavior via heatmaps and session tracking.",
    tech: "HTML, CSS, JavaScript, React.js, Chakra UI",
    view: "https://hotjar-sufi-clone-u4-33eeac.netlify.app/",
    git: "https://github.com/suFi7867/Hotjar.com-Clone",
    video:
      "https://www.linkedin.com/feed/update/urn:li:activity:6983691453747073024/",
  },
  {
    type: "Personal",
    name: "Portfolio",
    image: portfolio,
    description:
      "Personal portfolio website showcasing professional experience, projects, and skills.",
    tech: "React.js, Chakra UI, JavaScript, CSS",
    view: "https://sufi-portfolio.vercel.app/",
    video:
      "https://www.linkedin.com/feed/update/urn:li:activity:7025425586713956352/",
  },
  {
    type: "Personal",
    name: "Chatting App",
    image: stackbox,
    description:
      "Real-time chat app built with Socket.io, authentication, and avatar support.",
    tech: "Node.js, WebSocket, React.js, MongoDB, Express, Mongoose, Material UI",
    view: "https://stackbox.vercel.app/",
    git: "https://github.com/suFi7867/chat-box",
    video:
      "https://www.linkedin.com/feed/update/urn:li:activity:6983691453747073024/",
  },
  {
    type: "Freelance",
    name: "Student Management System",
    image: management,
    description:
      "Student Management system with CRUD operations, filters, and dark theme.",
    tech: "React.js, Redux, JavaScript, Chakra UI",
    git: "https://github.com/suFi7867/Employee-management-system",
    video:
      "https://www.linkedin.com/posts/sufiyan-shaikh-9bb808183_freelancing-studentmanagementsystem-axiosabrcrud-activity-6978627487182270464-uOxm?utm_source=share&utm_medium=member_desktop",
  },
  {
    type: "Personal",
    name: "Youtube Clone",
    image: youtube,
    description:
      "YouTube UI clone with API integration, debouncing, and top trending video playback.",
    tech: "HTML, CSS, JavaScript, Axios",
    view: "https://youtube-sufi-javascript.netlify.app/youtube.html",
    video:
      "https://www.linkedin.com/posts/sufiyan-shaikh-9bb808183_youtube-youtube-masaischool-activity-6951419073243025408-d8vk?utm_source=share&utm_medium=member_desktop",
  },
  {
    type: "Personal",
    name: "Uborik.com",
    image: uborik,
    description:
      "Online shopping site for clothing built within a week. Fully responsive UI with team collaboration.",
    tech: "React.js, Chakra UI, JavaScript, CSS",
    view: "https://uborik-com-8bad69.netlify.app/landingpage.html",
    git: "https://github.com/suFi7867/Uborik.com-Clone",
    video:
      "https://www.linkedin.com/posts/sufiyan-shaikh-9bb808183_masaischool-masai-codinglife-activity-6957002222199037952-Xzto?utm_source=share&utm_medium=member_desktop",
  },
  {
    type: "Personal",
    name: "Naukri.com",
    image: naukri,
    description:
      "Recruitment platform clone for job seekers and recruiters, built collaboratively in 7 days.",
    tech: "HTML, CSS, JavaScript",
    view: "https://naukri-com-sufi-8ba69b.netlify.app/",
    git: "https://github.com/Sandipmaury/naukri",
    video:
      "https://drive.google.com/file/d/1eBPV7ueb9dzZ-2hp_T-p1WqMjKCuXoY4/view",
  },

  // 💼 FREELANCE PROJECTS
  {
    type: "Freelance",
    name: "Makos Infotech",
    image: makosGIF,
    description:
      "IT consultation website showcasing services, portfolio, and company information.",
    tech: "React.js, Chakra UI, JavaScript, Email.js",
    view: "https://makos-digital.vercel.app/",
    git: "https://github.com/suFi7867/Makos-Digital",
    //video: "https://www.linkedin.com/feed/update/urn:li:activity:6983691453747073024/",
  },

  {
    type: "Company",
    name: "Okas Property (Real Estate Management)",
    description:
      "Real estate management system with dashboards, property listings, and analytics for agents and clients.",
    tech: "React.js, Node.js, Express, MongoDB, AntDesign UI, Redux",
  },
  {
    type: "Company",
    name: "US–UK Billing Platform (Utilities & Services)",
    description:
      "Enterprise billing platform for petroleum, electricity, and gas utilities with automated invoicing, analytics, and role-based dashboards.",
    tech: "React.js, TypeScript, Material UI, TanStack Query, MirageJS, Azure, Redux",
  },
  {
    type: "Freelance",
    name: "Artfluir.com",
    image: artfluir,
    description:
      "Artist-focused social media and marketplace for sharing, buying, and selling music and art.",
    tech: "Next.js,Tailwind CSS, ShadCN UI, Node.js, Supabase",
    view: "https://artfluir.vercel.app/",
  },
  {
    type: "Company",
    name: "Tech Trade Enterprises",
    image: techTrade,
    description:
      "Corporate website for Tech Trade Enterprises showcasing services, products, and contact info.",
    tech: "Next.js,Tailwind CSS, ShadCN UI, Node.js, Supabase",
    view: "https://www.techtradeenterprises.site/",
  },
  {
    type: "Freelance",
    name: "Pehchaan",
    image: pehchaan,
    description:
      "Pehchaan is a platform that offers fully customizable personal portfolio websites absolutely free, helping individuals build their online identity with ease.",
    tech: "Next.js, Tailwind CSS, Supabase",
    view: "https://pehchaaan.vercel.app/",
  },
  // 🏢 COMPANY PROJECTS
  {
    type: "Company",
    name: "Job Portal",
    image: xseedAI,
    description:
      "AI-powered job portal with resume parsing, Kanban pipeline, video/audio screening, and CI/CD setup across environments. Led frontend team of 7+.",
    tech: "Next.js, TypeScript, ShadCN UI, Tailwind, TanStack Query, MirageJS, Azure, Vercel",
    view: "https://xseed-ai-dev.vercel.app/",
  },
  {
    type: "Company",
    name: "Health AI Assistant / Max AI / MIA AI",
    description:
      "AI assistants for healthcare automation including appointment booking, data handling, and analytics using WebSockets and Firebase.",
    tech: "React.js, Node.js, Firebase, MongoDB, WebSockets, AI/ML",
  },
  {
    type: "Company",
    name: "Eligibility Flow (Healthcare Chat Assistant)",
    description:
      "Chat-based healthcare eligibility verification system using React.js, Recoil, and secure APIs with real-time Firebase sync.",
    tech: "React.js, Recoil, Firebase, WebSockets, Node.js, MongoDB",
  },
  {
    type: "Company",
    name: "Plan Keeper (US Client)",
    image: planKeeper,
    description:
      "Collaborated directly with the client to stabilize and scale the product. Built new components, fixed bugs, and improved performance using AI-assisted tools.",
    tech: "Next.js, Material UI, Supabase, WebSockets, AI/ML, Vercel v0.dev",
  },
];

const Project = () => {
  const [data, setData] = useState(projects);

  const FilterData = (type) => {
    if (type == "All") {
      setData(projects);
      return;
    }

    const newData = projects.filter((el) => el.type == type);
    setData(newData);
  };

  useEffect(() => {
    Aos.init({
      duration: 600,
    });
  }, []);

  const bg = useColorModeValue(
    "linear-gradient(3deg, rgba(216,241,255,1) 0%, rgba(175,188,255,0) 100%)",
    "linear-gradient(221deg, rgba(14,4,4,1) 0%, rgba(61,61,61,1) 51%, rgba(64,64,64,1) 60%, rgba(55,55,55,1) 70%, rgba(14,4,4,1) 100%)"
  );

  const HeadingColor = useColorModeValue("black", "white");
  const QueryColor = useColorModeValue("#e53e3e", "#eac288");

  const divColor = useColorModeValue("white", "rgba(255, 255, 255, 0.1)");
  const selected = useColorModeValue("#e53e3e", "#b5925f");

  const descColor = useColorModeValue("gray.500", "white");
  const selectedGit = useColorModeValue("gray.600", "#eac288");

  const borderColor = useColorModeValue("#eeee", "#f8f9fa");

  const buttonData = [
    { name: "All", value: "All" },
    { name: "Company", value: "Company" },
    { name: "Freelance", value: "Freelance" },
    { name: "Personal", value: "Personal" },
  ];

  const [selectedBtn, setSelectedBtn] = useState(0);

  return (
    <Stack id="projects" w="full" bg={bg}>
      <Stack
        data-aos="fade-right"
        justifyContent={{ base: "space-around", sm: "space-around" }}
        alignItems="center"
        p={{ base: 0, sm: 8 }}
        alignSelf="center"
        justify="center"
        w="full"
        maxW="1400px"
        flexFlow={"column"}
      >
        <Tilt>
          <Stack data-aos="fade-up">
            <Text
              color={HeadingColor}
              marginTop={50}
              fontSize={{ base: "3xl", sm: "4xl", md: "4xl" }}
              fontWeight="semibold"
            >
              <Highlight query="Projects" styles={{ color: QueryColor }}>
                My Creative Projects
              </Highlight>
            </Text>
          </Stack>
        </Tilt>

        <HStack
          data-aos="zoom-in"
          justifyContent="center"
          w="full"
          spacing={{ base: 2, sm: 5 }}
          p={5}
        >
          {buttonData.map((el, i) => (
            <Button
              borderRadius={5}
              onClick={() => {
                FilterData(el.value);
                setSelectedBtn(i);
              }}
              color={selectedBtn === i ? "white" : "none"}
              bg={selectedBtn === i ? selected : "whiteAlpha.200"}
              _hover={{ bg: selected, color: "white" }}
              boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
              fontWeight="medium"
            >
              {el.name}
            </Button>
          ))}
        </HStack>

        <SimpleGrid
          p={{ base: "1", md: 5 }}
          spacing={{ base: 0, md: 5, lg: 6 }}
          columns={{ base: 2, md: 2, lg: 3, xl: 4 }}
        >
          {data.map((el) => (
            <VStack
              boxShadow={{
                base: "none",
                md: "rgba(0, 0, 0, 0.14) 0px 3px 8px",
              }}
              maxW="320px"
              h={{ base: "100%", lg: "fit-content" }}
              id="box"
              border={{ base: "1px solid" + borderColor, md: "none" }}
              borderRadius={{ base: "0", md: 5 }}
              bg={divColor}
              p={{ base: "3", md: 4 }}
              spacing={{ base: "0", md: 4 }}
            >
              {el?.image && (
                <VStack>
                  <Image
                    mb={{ base: "10px", md: "none" }}
                    borderRadius={5}
                    src={el.image}
                    alt="sufi"
                    w="100%"
                    minW="100%"
                    h={{ base: "100%", md: "150px", lg: "150px", xl: "150px" }}
                    objectFit="cover"
                  />
                </VStack>
              )}

              <Text
                fontSize={{ base: "md", md: "xl", lg: "xl", xl: "xl" }}
                fontWeight="semibold"
              >
                {el.name}
              </Text>
              <VStack>
                <Text
                  display={{ base: "none", sm: "inline-flex" }}
                  fontSize={{ base: "13px", md: "12px", lg: "12px", xl: "sm" }}
                  color={descColor}
                >
                  {el.description}
                </Text>

                <Text
                  w="100%"
                  fontSize={{ base: "12px", md: "sm", lg: "12px", xl: "sm" }}
                  marginTop={50}
                  textAlign={{ base: "center", md: "start" }}
                  fontWeight="medium"
                >
                  <Highlight
                    query="Tech Stack"
                    styles={{
                      color: QueryColor,
                      fontWeight: "semibold",
                    }}
                  >
                    {`Tech Stack - ${el.tech}`}
                  </Highlight>
                </Text>

                <HStack spacing={{ base: "0", md: 5 }}>
                  {el.video && (
                    <a href={el.video} target="_blank">
                      <Text
                        color={selectedGit}
                        fontSize={{ base: "md", lg: "xl" }}
                        className="projectButton"
                      >
                        <GoDeviceCameraVideo />
                      </Text>
                    </a>
                  )}

                  {el.view && (
                    <a href={el.view} target="_blank">
                      <Text
                        color={selectedGit}
                        fontSize={{ base: "md", lg: "xl", xl: "2xl" }}
                        className="projectButton"
                      >
                        <ViewIcon />
                      </Text>
                    </a>
                  )}

                  {el.git && (
                    <a href={el.git} target="_blank">
                      <Text
                        color={selectedGit}
                        fontSize={{ base: "md", lg: "xl", xl: "2xl" }}
                        className="projectButton"
                      >
                        <BsGithub />
                      </Text>
                    </a>
                  )}
                </HStack>
              </VStack>
            </VStack>
          ))}
        </SimpleGrid>
      </Stack>
    </Stack>
  );
};

export default Project;

/*{
    category:"React",
    name:"Employee Management",
    image:"https://i.im.ge/2022/10/18/20FIya.bloggif-634e5a001c1f6.gif",
    description :`It's my major project for a HIGH SCHOOL in our Town
    they asked me for a Sample Project and I Made This as Front-End-Developer, smooth UI, sorting, pagination, crud operation, filter, dark theme`,
    tech:"ReactJS, Redux, JavaScript , ChakraUI, CSS, NodeJS, Express, MongoDB",
    video:"https://www.linkedin.com/posts/sufiyan-shaikh-9bb808183_freelancing-studentmanagementsystem-axiosabrcrud-activity-6978627487182270464-uOxm?utm_source=share&utm_medium=member_desktop",
    view:"https://bewakoof-clone-sufi.vercel.app/",
    git:"https://github.com/suFi7867/Employee-management-system"
  },*/
